"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.component = exports.HeroBannerComponent = void 0;
const app_1 = require("app");
class HeroBannerComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.hero-banner';
        this.VISIBLE_LINES_COUNT_ON_MOBILE = 2;
        this.BASE_LINE = 24;
        this.visibleAreaMaxHeight = this.BASE_LINE * this.VISIBLE_LINES_COUNT_ON_MOBILE;
        this.expandableDescriptionInitialized = false;
        this.initExpandableDescription = () => {
            this.handleControls();
            this.handleDescription();
            this.expandableDescriptionInitialized = true;
        };
        this.handleControls = () => {
            if (this.description && this.description.scrollHeight > this.visibleAreaMaxHeight) {
                this.descriptionControls.classList.remove('hidden');
            }
            else {
                this.descriptionControls.classList.add('hidden');
            }
        };
        this.handleDescription = () => {
            if (this.expandableDescriptionInitialized) {
                return;
            }
            this.readMoreBtn.addEventListener('click', () => {
                this.description.classList.remove('line-clamp-2');
                this.readMoreBtn.classList.add('!hidden');
                this.readLessBtn.classList.remove('hidden');
            });
            this.readLessBtn.addEventListener('click', () => {
                this.description.classList.add('line-clamp-2');
                this.readMoreBtn.classList.remove('!hidden');
                this.readLessBtn.classList.add('hidden');
            });
        };
    }
    BeforeInit() {
        if (!this.el[0]) {
            return;
        }
        this.description = this.el[0].querySelector('.hero-banner__info_description');
        this.descriptionControls = this.el[0].querySelector('.expandable-text-controls');
        this.readMoreBtn = this.el[0].querySelector('.expandable-text-read-more');
        this.readLessBtn = this.el[0].querySelector('.expandable-text-read-less');
    }
    OnInit() {
        this.initExpandableDescription();
    }
    OnWindowResizeThrottle() {
        this.initExpandableDescription();
    }
}
exports.HeroBannerComponent = HeroBannerComponent;
exports.component = new HeroBannerComponent();
